'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _systemAide = require('./system-aide');

var _systemAide2 = _interopRequireDefault(_systemAide);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var systemAideInstance = getNewInstance();
/* eslint-disable no-new */
function getNewInstance() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var instance = new _vue2.default({
    render: function render(h) {
      return h(_systemAide2.default, {
        props: options
      });
    }
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  return instance.$children[0];
}
exports.default = {
  init: function init() {
    this.destroy();
    systemAideInstance = getNewInstance.apply(this, arguments);
    return this;
  },
  show: function show(isShow) {
    systemAideInstance.isShow = isShow;
    return this;
  },
  update: function update(content) {
    systemAideInstance.content = content;
    return this;
  },
  destroy: function destroy() {
    document.body.removeChild(systemAideInstance.$el);
  }
};